<template>
    <div class="memo-cell" :class="{ editing: isEditing }">
        <textarea
            v-if="isEditing"
            ref="ta"
            v-model="draft"
            class="memo-textarea"
            rows="3"
            :placeholder="placeholder"
            @blur="onBlur"
            @keydown.esc.prevent="onCancel"
            @keydown.enter.ctrl.prevent="onBlur"
            @keydown.enter.meta.prevent="onBlur"
        ></textarea>
        <div
            v-else-if="content"
            class="memo-text"
            :title="content"
            @click="startEdit"
        >{{ content }}</div>
        <button
            v-else
            type="button"
            class="memo-add"
            :title="placeholder"
            @click="startEdit"
        >+</button>
        <span v-if="savedFlash" class="memo-flash">✓</span>
        <span v-if="saving" class="memo-flash saving">…</span>
    </div>
</template>

<script>
export default {
    name: 'MemoCell',
    props: {
        content: { type: String, default: '' },
        placeholder: { type: String, default: '메모 추가' }
    },
    data() {
        return {
            isEditing: false,
            draft: '',
            saving: false,
            savedFlash: false,
            cancelled: false
        }
    },
    methods: {
        startEdit() {
            this.draft = this.content || ''
            this.cancelled = false
            this.isEditing = true
            this.$nextTick(() => {
                if (this.$refs.ta) {
                    this.$refs.ta.focus()
                }
            })
        },
        async onBlur() {
            if (!this.isEditing) return
            if (this.cancelled) {
                this.isEditing = false
                return
            }
            const next = (this.draft || '').trim()
            const prev = (this.content || '').trim()
            this.isEditing = false
            if (next === prev) return  // 변경 없으면 저장 안 함

            this.saving = true
            try {
                await Promise.resolve(this.$emit('save', next))
                // 부모가 비동기 처리. 부모 쪽에서 props가 갱신되면 content가 next로 변함.
                // 단순화: 부모가 onSave를 async로 받기 위해 emit 후 짧게 flash
                this.savedFlash = true
                setTimeout(() => { this.savedFlash = false }, 800)
            } finally {
                this.saving = false
            }
        },
        onCancel() {
            this.cancelled = true
            this.isEditing = false
            this.draft = this.content || ''
        }
    }
}
</script>

<style lang="scss" scoped>
.memo-cell {
    position: relative;
    width: 100%;
    min-height: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
}

.memo-text {
    width: 100%;
    max-height: 38px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 12px;
    line-height: 1.3;
    cursor: text;
    color: #333;
    padding: 4px 6px;
    border-radius: 4px;
    transition: background 0.15s;
    white-space: pre-wrap;
    word-break: break-word;

    &:hover {
        background: #f4f5fa;
    }
}

.memo-add {
    width: 28px;
    height: 24px;
    background: transparent;
    border: 1px dashed #ced4da;
    border-radius: 4px;
    color: #adb5bd;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    padding: 0;
    transition: all 0.15s;

    &:hover {
        color: #495057;
        border-color: #495057;
        border-style: solid;
        background: #f8f9fa;
    }
}

.memo-textarea {
    width: 100%;
    min-height: 64px;
    padding: 6px 8px;
    border: 1px solid #fbc02d;
    border-radius: 4px;
    outline: none;
    font-size: 12px;
    line-height: 1.4;
    resize: vertical;
    background: #fffdf3;
    font-family: inherit;

    &:focus {
        border-color: #f57f17;
        box-shadow: 0 0 0 2px rgba(251, 192, 45, 0.2);
    }
}

.memo-flash {
    position: absolute;
    top: 2px;
    right: 4px;
    font-size: 11px;
    color: #28a745;
    background: rgba(255, 255, 255, 0.9);
    padding: 1px 4px;
    border-radius: 8px;
    pointer-events: none;

    &.saving {
        color: #6c757d;
    }
}
</style>
